import {
  Button,
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Paper,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { Component } from "react";

import SectorFamilyService from "../../../tools/SectorFamilyService";
import TreatmentsService from "../../../tools/TreatmentsService";

//msgs
import { connect } from "react-redux";
import { msgSimple } from "../../../actions/snackbarActions";

import { ProfileOptionPassaenger } from "../../../enums.js";

class ModalPassengers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: "",
      user: {
        id: "new",
        first_name: "",
        last_name: "",
        profile: "Passageiro",
        rg: "",
        cpf: "",
        active: true,
        email: "",
        phone: "",
        is_user: false,
        password: "",
        weight: "",
        flights: "0",
      },
      profiles: ProfileOptionPassaenger,
    };
  }

  onRender = () => {
    const modal = this.props.modal;
    SectorFamilyService.get(null, null, 1, null, true).then((result) => {
      this.setState({ loading: false });
      if (result.ok) {
        this.setState({ sectors: result.response });
      }
    });

    TreatmentsService.get(null, null, 1, null, true).then((result) => {
      this.setState({ loading: false });
      if (result.ok) {
        this.setState({ treatments: result.response });
      }
    });

    if (modal.id !== "new") {
      this.setState({ user: modal });
    } else {
      this.setState({
        user: {
          id: "new",
          first_name: "",
          last_name: "",
          rg: "",
          cpf: "",
          active: true,
          email: "",
          phone: "",
          is_user: false,
          password: "",
          weight: "",
          flights: "0",
          profile: "",
        },
      });
    }
  };

  render() {
    return (
      <Modal
        style={{ overflowX: "hidden" }}
        open={this.props.openModal}
        onRendered={this.onRender}
      >
        <Grid
          style={{ height: "100%", overflowX: "hidden" }}
          justify="center"
          alignItems="center"
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
        >
          <Grid item container xs={12} sm={8} md={8} lg={8} xl={4}>
            <Paper style={{ height: "100%", width: "100%", padding: 25 }}>
              <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="title" id="modal-title">
                  {this.props.modal.id === "new"
                    ? "Novo Passageiro"
                    : "Editar Passageiro"}
                </Typography>
              </Grid>
              <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  style={{ marginTop: 14, marginRight: 10 }}
                  variant="subheading"
                  id="modal-title"
                >
                  Ativo:
                </Typography>
                <FormControlLabel
                  control={
                    <Switch
                      id="active"
                      checked={this.state.user.active}
                      onChange={(event) => {
                        let { user } = this.state;
                        this.setState({
                          user: { ...user, active: event.target.checked },
                        });
                      }}
                      color="primary"
                    />
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                container
                spacing={8}
              >
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <TextField
                    id="first_name"
                    label="Primeiro Nome *"
                    style={{ width: "100%" }}
                    value={this.state.user.first_name}
                    onChange={(event) => {
                      let { user } = this.state;
                      this.setState({
                        user: { ...user, first_name: event.target.value },
                      });
                    }}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <TextField
                    id="last_name"
                    label="Ultimo Nome *"
                    style={{ width: "100%" }}
                    value={this.state.user.last_name}
                    onChange={(event) => {
                      let { user } = this.state;
                      this.setState({
                        user: { ...user, last_name: event.target.value },
                      });
                    }}
                    margin="normal"
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  id="email"
                  label="E-mail *"
                  style={{ width: "100%" }}
                  value={this.state.user.email}
                  onChange={(event) => {
                    let { user } = this.state;
                    this.setState({
                      user: { ...user, email: event.target.value },
                    });
                  }}
                  margin="normal"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                container
                spacing={8}
              >
                <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                  <TextField
                    id="phone"
                    label="Telefone *"
                    type="phone"
                    style={{ width: "100%" }}
                    value={this.state.user.phone}
                    onChange={(event) => {
                      let { user } = this.state;
                      this.setState({
                        user: { ...user, phone: event.target.value },
                      });
                    }}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                  <TextField
                    id="rg"
                    label="RG"
                    style={{ width: "100%" }}
                    value={this.state.user.rg}
                    onChange={(event) => {
                      let { user } = this.state;
                      this.setState({
                        user: { ...user, rg: event.target.value },
                      });
                    }}
                    margin="normal"
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                  <TextField
                    id="cpf"
                    label="CPF *"
                    style={{ width: "100%" }}
                    value={this.state.user.cpf}
                    onChange={(event) => {
                      let { user } = this.state;
                      this.setState({
                        user: { ...user, cpf: event.target.value },
                      });
                    }}
                    margin="normal"
                  />
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                container
                spacing={8}
              >
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <TextField
                    id="weight"
                    type="number"
                    label="Peso *"
                    style={{ width: "100%" }}
                    value={this.state.user.weight}
                    onChange={(event) => {
                      let { user } = this.state;
                      this.setState({
                        user: { ...user, weight: event.target.value },
                      });
                    }}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <TextField
                    number
                    disabled={true}
                    id="flights"
                    label="Qtd Voos"
                    style={{ width: "100%" }}
                    value={this.state.user.flights}
                    onChange={(event) => {
                      let { user } = this.state;
                      this.setState({
                        user: { ...user, flights: event.target.value },
                      });
                    }}
                    margin="normal"
                  />
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                container
                spacing={8}
              >
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={2}
                  alignItems="center"
                >
                  <Typography
                    variant="subheading"
                    id="modal-title"
                    style={{ marginRight: 10 }}
                  >
                    Usuário?
                  </Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        id="is_user"
                        checked={this.state.user.is_user}
                        onChange={(event) => {
                          let { user } = this.state;
                          this.setState({
                            user: { ...user, is_user: event.target.checked },
                          });
                        }}
                        color="primary"
                      />
                    }
                  />
                </Grid>
                {this.state.user.is_user && (
                  <React.Fragment>
                    <Grid item xs={12} sm={12} md={5}>
                      <TextField
                        id="profile"
                        select
                        label="Perfil *"
                        style={{ width: "100%" }}
                        value={this.state.user.profile}
                        onChange={(event) => {
                          let { user } = this.state;
                          this.setState({
                            user: { ...user, profile: event.target.value },
                          });
                        }}
                        margin="normal"
                      >
                        <MenuItem disabled>Selecione o Perfil</MenuItem>
                        {this.state.profiles &&
                          this.state.profiles.map((profile) => (
                            <MenuItem key={profile} value={profile}>
                              {profile}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                    {
                      this.state.user.id === 'new' && <Grid item xs={12} sm={12} md={5}>
                      <TextField
                        label="Senha* (Login)"
                        style={{ width: "100%" }}
                        value={this.state.user.password}
                        onChange={(event) => {
                          let { user } = this.state;
                          this.setState({
                            user: { ...user, password: event.target.value },
                          });
                        }}
                        margin="normal"
                      />
                    </Grid>
                    }
                  </React.Fragment>
                )}
              </Grid>

              <Grid
                style={{ marginTop: 40 }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
              >
                <Button
                  style={{ float: "right" }}
                  color="secondary"
                  onClick={() => this.props.func()}
                >
                  Cancelar
                </Button>
                <Button
                  style={{ float: "right" }}
                  color="primary"
                  onClick={() => {
                    if (this.state.user.is_user && this.state.user.id === "new" && (this.state.user.password === "" || this.state.user.password === undefined)) {
                      this.props.msgSimple("Preencha os campos obrigatórios.");
                    }
                    else if (
                      this.state.user.is_user &&
                      this.state.user.profile === ""
                    ) {
                      this.props.msgSimple("Preencha os campos obrigatórios.");
                    } else if (
                      this.state.user.last_name !== "" &&
                      this.state.user.first_name !== "" &&
                      this.state.user.email !== "" &&
                      this.state.user.cpf !== "" &&
                      this.state.user.weight !== "" &&
                      this.state.user.phone !== ""
                    ) {
                      if (!this.state.user.is_user) {
                        this.state.user.profile = "";
                      }
                      this.props.handleSave(this.state.user);
                    } else {
                      this.props.msgSimple("Preencha os campos obrigatórios.");
                    }
                  }}
                >
                  Salvar
                </Button>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  msgSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalPassengers);



// WEBPACK FOOTER //
// ./src/routes/settings/passengers/Modal.js